import moment from 'moment';
import React from 'react';
import { DataTable } from '../widgets';
import { DataTableRecordsNotFound } from '../widgets/DataTable';
import { secondsToTime, toDisplayTimeString } from '../../helpers/moment-ex';

const TripHistoryTable = ({ data, timezoneIdentifier }) => {
    const getEntryExitTime = (fieldIn, fieldOut) => {
        const date = moment.utc(fieldIn).tz(timezoneIdentifier).format("DD MMM YYYY");
        const entry = moment.utc(fieldIn).tz(timezoneIdentifier).format("hh:mm:ss a");
        const exit = moment.utc(fieldOut).tz(timezoneIdentifier).format("hh:mm:ss a");
        const arrow = <i className='fa fa-long-arrow-right i-arrow' />;

        return <><span>{date} ({entry} {arrow} {exit})</span></>;
    }

    const getDuration = (entry, exit) => {
        const entrySec = moment.utc(entry).tz(timezoneIdentifier);
        const exitSec = moment.utc(exit).tz(timezoneIdentifier);
        const seconds = exitSec.diff(entrySec, 'seconds');

        return toDisplayTimeString(secondsToTime(seconds, true));
    }

    return (
        <>
            <DataTable className='mt-5 mb-5' striped bordered hover>
                <DataTable.Header>
                    <DataTable.Row>
                        <DataTable.Cell width="30px" className="sort-column">#</DataTable.Cell>
                        <DataTable.Cell width="300px" className="sort-column">EG</DataTable.Cell>
                        <DataTable.Cell width="300px" className="sort-column">Region Name</DataTable.Cell>
                        <DataTable.Cell width="300px" className="sort-column">Trips Time</DataTable.Cell>
                        <DataTable.Cell width="300px" className="sort-column">Duration</DataTable.Cell>
                    </DataTable.Row>
                </DataTable.Header>
                <DataTable.Body>
                    {data.map((e, index) => (
                        <DataTable.Row key={index}>
                            <DataTable.Cell>{index + 1}</DataTable.Cell>
                            <DataTable.Cell>{e.eg}</DataTable.Cell>
                            <DataTable.Cell><b>{e.regionName}</b></DataTable.Cell>
                            <DataTable.Cell>{getEntryExitTime(e.enter, e.exit)}</DataTable.Cell>
                            <DataTable.Cell>{getDuration(e.enter, e.exit)}</DataTable.Cell>
                        </DataTable.Row>
                    ))}
                </DataTable.Body>
            </DataTable>
            {data.length === 0 && <DataTableRecordsNotFound />}
        </>
    )
}

export default TripHistoryTable;